<div class="page-header ac-flex-col">
  @if (showHeroCards() && heroCards()?.length) {
  <app-carousel [title]="lobbyTitle() ?? null" titleClass="ac-headline-sm">
    @for (card of heroCards(); track card.hero_card_id) {
      <app-slide>
        <button
          mat-flat-button
          class="lobby-card-button"
          type="button"
          (authClick)="onHeroCardClick(card)"
          trackEvent="hero_card_select"
          [trackEventParams]="{ hero_card: card.analytics_key ?? card.hero_card_id }"
          [require]="card.action_requires_auth">
          <!-- TODO: Need to add an accessibility prop to hero card at some point so we can reference it in alt here -->
          <app-image-loader
            class="hero-card-image"
            [src]="card.image_url"
            [alt]="'Hero card' + card.hero_card_id"
            [spinnerSize]="device.isMobile() ? 20 : 32"
          />
        </button>
      </app-slide>
    }
  </app-carousel>
  } @else {
    @if (showHeroCardsLoading()) {
      <!-- height + lobby title + gap = 241 -->
      <div [style.height.px]="241"></div>
    } @else {
      <div class="ac-headline-sm">
        {{ lobbyTitle() }}
      </div>
    }
  }

  <div class="sticky-nav ac-flex-col ac-gap-xl">
    <mat-form-field
      subscriptSizing="dynamic"
      class="game-name-search ac-form-field-sm ac-rounded">
      <div matPrefix class="prefix">
        <ac-icon iconKey="hr:search" [size]="32" />
      </div>
      <input
        matInput
        type="text"
        [formControl]="nameSearchFormControl"
        placeholder="Search for games"
      />
    </mat-form-field>

    @if (allGameCollections()?.length) {
      <ac-single-select-group
        #quickNav class="collection-quick-nav"
        [selectedValue]="selectedCollectionId()"
        (selectedValueChange)="scrollToCollection($event)">
        @for (collection of allGameCollections(); track collection.game_collection_id) {
          <ac-single-select
            [value]="collection.game_collection_id"
            [attr.data-id]="collection.game_collection_id"
            trackEvent="game_category_tab_select"
            pageArea="home"
            [trackEventParams]="{ category: collection.analytics_key ?? collection.game_collection_id }">
            @if (collection.icon_url) {
              <ac-icon [iconUrl]="collection.icon_url" [size]="16" />
            }
            <span class="view-label">
              {{ collection.title }}
            </span>
          </ac-single-select>
        }
      </ac-single-select-group>
    } @else if (!allGameCollections()) {
      <div class="skeleton-quick-nav">
        @for (i of skeletonCarousels; track i) {
          <div class="skeleton-chip"></div>
        }
      </div>
    }
  </div>

  @if (allGameCollections()) {
    @for (collection of allGameCollections(); track collection.game_collection_id) {
      <app-carousel
        [id]="'collection-' + collection.game_collection_id"
        class="game-carousel"
        [class.collection-first]="$index === 0"
        [title]="collection.title"
        [iconUrl]="collection.icon_url"
        [viewAllLink]="collection.view_all_link ?? undefined">
        @for (game of collection.games; track game.game_id) {
          <app-slide>
            <app-game-card [game]="$any(game)" analyticsPageArea="home" [analyticsEventSource]="collection.analytics_key ?? collection.game_collection_id + '_carousel'" />
          </app-slide>
        } @empty {
          <app-slide class="loading-games">
            <div class="game-button ac-flex ac-ctr">
              <ac-loading [size]="40" />
            </div>
          </app-slide>
        }
      </app-carousel>
    }
  } @else {
    @for (i of skeletonCarousels; track i) {
      <div class="skeleton-carousel game-carousel">
        <div class="skeleton-header">
          <div class="skeleton-title"></div>
        </div>
        <div class="skeleton-cards">
          @for (j of skeletonCards; track j) {
            <div class="skeleton-card"></div>
          }
        </div>
      </div>
    }
  }

  <app-carousel title="Providers" iconUrl="{{ 'cdnUrl' | env }}/icons/hr/providers.svg" class="game-carousel">
    @for (provider of providers(); track provider.id) {
      <app-slide>
        <button
          mat-flat-button
          class="provider-button"
          type="button"
          trackEvent="game_provider_tab_select"
          [trackEventParams]="{ game_provider_id: provider.id }"
          [routerLink]="'/providers/' + provider.id">
          <img
            src="{{ 'cdnUrl' | env }}/icons/provider/{{ provider.id }}.svg"
            [alt]="provider.name"
            class="provider-icon"
          />
        </button>
      </app-slide>
    }
  </app-carousel>

  <div class="description-cards ac-flex ac-gap-lg">
    <button
      mat-flat-button
      class="no-purchase-necessary"
      type="button"
      (click)="openNoPurchaseNecessary()">
      <div class="content ac-flex-col ac-gap-lg">
        <div class="ac-flex-col ac-algn-strt ac-gap-sm">
          <div class="title ac-headline-sm">No Purchase Necessary</div>
          <div class="description ac-label ac-body-md">
            Jump right into action by claiming free Gold Coins and Sweeps Coins
            - absolutely no payment is required to start playing!
          </div>
        </div>
        <div class="learn-more-btn ac-flex ac-algn-ctr ac-gap-xs ac-title-sm ac-pd-sm-md">
          Learn More
          <ac-icon iconKey="hr:arrow_right" [size]="12" />
        </div>
      </div>
      <img
        src="{{ 'cdnUrl' | env }}/images/lobby/no_purchase_necessary_icon.webp"
        alt="no purchase necessary"
        class="no-purchase-necessary-img"
      />
    </button>
    <button
      mat-flat-button
      class="claim-your-sc"
      type="button"
      (authClick)="walletDialog.openDailyClaim()">
      <div class="content ac-flex-col ac-gap-lg">
        <div class="ac-flex-col ac-algn-strt ac-gap-sm">
          <div class="title ac-headline-sm">Claim Your SC</div>
          <div class="description ac-label ac-body-md">
            Earn free Sweeps Coins through Daily Rewards, Gameplay Bonuses,
            Races, Loyalty Drops, Mail-in Requests, or as a bonus with your Gold
            Coin purchases.
          </div>
        </div>
        <div
          class="learn-more-btn ac-flex ac-algn-ctr ac-gap-xs ac-title-sm ac-pd-sm-md">
          Claim Now
          <ac-icon iconKey="hr:arrow_right" [size]="12" />
        </div>
      </div>
      <img
        src="{{ 'cdnUrl' | env }}/images/lobby/claim_sc.webp"
        alt="claim your sc"
        class="claim-your-sc-img"
      />
    </button>
  </div>
</div>
